// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hive_s1w6rhsl{text-align:center;margin-bottom:auto;}\n", ""]);
// Exports
module.exports = exports;
